import React, { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
//////////////////////////////////////////////////////////
import i18n from '@/i18n';
import {
	Button,
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
} from '@/app/shared/components';
import { WelcomePopup } from '@/core/interfaces';
import { DialogTitle } from '@radix-ui/react-dialog';

interface OnboardingProps {
	action: Dispatch<SetStateAction<boolean>>;
	showOnboardingPageZero: boolean;
	welcomePopup: WelcomePopup | null;
}
export const Onboarding: React.FC<OnboardingProps> = ({
	action,
	showOnboardingPageZero,
	welcomePopup,
}) => {
	/*********************
	 // #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	 // #region States
	**********************/

	const [showDialog, setShowDialog] = useState<boolean>(
		welcomePopup ? true : false
	);

	/*********************
	 // #region Constants
	**********************/
	const data = [
		{
			id: 1,
			title: i18n.t('onboarding.step1.title'),
			description: i18n.t('onboarding.step1.description'),
			img: process.env.VITE_ONBOARDING_FIRST_IMAGE,
		},
		{
			id: 2,

			title: i18n.t('onboarding.step2.title'),
			description: i18n.t('onboarding.step2.description'),
			img: process.env.VITE_ONBOARDING_SECOND_IMAGE,
		},
		{
			id: 3,

			title: i18n.t('onboarding.step3.title'),
			description: i18n.t('onboarding.step3.description'),
			img: process.env.VITE_ONBOARDING_THIRD_IMAGE,
		},
		{
			id: 4,
			title: i18n.t('onboarding.step4.title'),
			description: i18n.t('onboarding.step4.description'),
			img: process.env.VITE_ONBOARDING_FIFTH_IMAGE,
		},
		{
			id: 5,
			title: i18n.t('onboarding.step5.title'),
			description: i18n.t('onboarding.step5.description'),
			img: process.env.VITE_ONBOARDING_FOURTH_IMAGE,
		},
		{
			id: 6,
			title: i18n.t('onboarding.step6.title'),
			description: i18n.t('onboarding.step6.description'),
			img: process.env.VITE_ONBOARDING_SIXTH_IMAGE,
		},
	];
	const stepZero = {
		id: 0,
		title: i18n.t('onboarding.step0.title'),
		description: i18n.t('onboarding.step0.description'),
		img: process.env.VITE_ONBOARDING_FIRST_IMAGE,
	};

	const onboardingSteps = showOnboardingPageZero
		? [stepZero, ...data]
		: [...data];

	/*********************
	 // #region Template
	**********************/
	return (
		<div className="flex flex-col gap-2">
			<Carousel>
				<CarouselContent>
					{onboardingSteps.map((item, index) => {
						return (
							<CarouselItem key={index}>
								<div className="flex items-center flex-col min-h-svh justify-center px-12 py-6 text-center gap-4">
									<div>
										<h1 className="text-2xl font-bold mb-2 leading-tight">
											{item.title}
										</h1>
										<p className="text-sm">
											{item.description}
										</p>
									</div>
									<div>
										<img
											className="Onboarding max-w-[80%]  mx-auto"
											src={item.img}
											alt={item.title}
										/>
									</div>
									<div className="w-full">
										{item.id === 6 && (
											<Button
												onClick={() => action(false)}
												variant={'secondary'}
											>
												{t('general.play')}
											</Button>
										)}
									</div>
								</div>
							</CarouselItem>
						);
					})}
				</CarouselContent>
				<CarouselPrevious
					variant={'arrow'}
					className="left-0 z-20 top-2/4 ml-4 hover:bg-transparent w-[30px]"
				/>
				<CarouselNext
					variant={'arrow'}
					className="right-0 z-20 top-2/4 mr-4 hover:bg-transparent w-[30px]"
				/>
			</Carousel>
			{welcomePopup && (
				<Dialog open={showDialog}>
					<DialogContent className="p-6 gap-6 w-auto min-w-[80%]">
						<DialogHeader className="gap-6">
							<DialogTitle className="hidden"></DialogTitle>
							<img src={welcomePopup.imageUrl} />
							<DialogDescription className="text-lg text-slate-100 p-0 mt-0 m-0 leading-1 space-y-0">
								{welcomePopup.text}
							</DialogDescription>
						</DialogHeader>
						<DialogFooter>
							<Button
								variant={'primary'}
								onClick={() => setShowDialog(false)}
							>
								{t('general.play')}
							</Button>
						</DialogFooter>
					</DialogContent>
				</Dialog>
			)}
		</div>
	);
};
